import { CheckoutFeedbackQuestionProjection, CheckoutFeedbackQuestionTypesWithChildren } from "./checkoutFeedback";
import { CheckoutFeedbackQuestionType } from "./checkoutFeedback.constants";

const checkoutFeedbackQuestionHasChildren = (
  question: CheckoutFeedbackQuestionProjection,
): question is CheckoutFeedbackQuestionProjection<CheckoutFeedbackQuestionTypesWithChildren> =>
  [
    CheckoutFeedbackQuestionType.HOST_DEFAULT,
    CheckoutFeedbackQuestionType.HOST_SELECT,
    CheckoutFeedbackQuestionType.HOST_TEXTAREA,
  ].includes(question.type);

export { checkoutFeedbackQuestionHasChildren };
